import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../actions/getUserData";
import { setAppLoader } from "../../actions/setAppLoader";
import success from "../../assets/images/Vector.svg";
import { saveFormPath } from "../../services/userService";
import ErrorModal from "../common/ErrorModal";
import CAlert from "../utils/CAlert";
import CButton from "../utils/CButton";
import CInput from "../utils/CInput";
import CircularLoader from "../utils/CircularLoader";
import {
  downloadDigilocker,
  initiateDigilocker,
} from "../../services/digilockerService";
import { set } from "date-fns";

export default function DigiLockerAadharVerification({
  setTabValue,
  setStepperCount,
  userDetailId,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [PAN, setPAN] = React.useState("");
  const [aadhaar, setAadhaar] = React.useState("");
  const [isPANVerify, setIsPANVerify] = React.useState(false);
  const [isAadharVerify, setIsAadharVerify] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const params = new URLSearchParams(location.search);
  const userDetails = useSelector((state) => state?.getUserData?.data);
  const isFetching = useSelector((state) => state?.getUserData?.isFetching);
  const userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : null;
  const userId = userData?.userId;
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const [technicalError, setTechnicalError] = React.useState(false);
  const [verificationStatus, setVerificationStatus] = React.useState("PENDING");
  const disabledButton = (verificationStatus !== 'VERIFIED');


  useEffect(() => {
    dispatch(getUserData(userDetailId || localStorage.getItem("detailId")));
  }, []);

  const getVericationStatusMessage = (status) => {
    switch (status) {
      case "PENDING":
        return "Validate Aadhar with Digilocker";
      case "INITIATE":
        return "Initiating verification...";
      case "INITIATED":
        return "Verifying Aadhaar...";
      case "SUCCESS":
        return "Downloading Aadhar...";
      case "VERIFIED":
        return "Aadhar Verified";
    }
  };

  const handleDigilockerClick = (token) => {
    if (window.DigiboostSdk) {
      window.DigiboostSdk({
        gateway: "production", // Use "production" for live environment
        token: token,
        selector: ".digilocker-button", // CSS selector for mounting
        style: {
          backgroundColor: "#D32F2F",
          color: "white",
          padding: "15px 30px",
          borderRadius: "8px",
          fontSize: "16px",
          fontWeight: "bold",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          transition: "all 0.3s ease",
          display: "none",
        },
        onSuccess: function (data) {
          // Handle successful verificationx
          console.log("User verified:", data);
          setVerificationStatus("SUCCESS");
          downloadDigilocker(userDetailId, data.client_id).then((res) => {
            console.log("downloadDigilocker::::res", res);
            if (res?.success) {
              setVerificationStatus("VERIFIED");
              alert("Verification was successful. Aadhaar Verified");
              onSubmitVerified({ preventDefault: () => {}, status: "VERIFIED" });
            }
          });
          // Example: Update UI
        },
        onFailure: function (error) {
          setError(true);
          setErrorMsg("Aadhaar Verification Failed, Please complete the verification to proceed");
          setVerificationStatus("PENDING");
          alert(error);
        },
      });
      setTimeout(() => {
        document
          .getElementsByClassName("digilocker-button")[0]
          .getElementsByTagName("button")[1]
          .click();
      }, 3000);
    } else {
      console.error("Digiboost SDK not loaded yet!");
    }
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/gh/surepassio/surepass-digiboost-web-sdk@latest/index.min.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script); // cleanup on unmount
    };
  }, []);

  //Show Loader
  React.useEffect(() => {
    dispatch(setAppLoader(isFetching));
  }, [isFetching]);

  React.useEffect(() => {
    if (verificationStatus === "failure") {
      setError(true);
      setErrorMsg("Aadhaar Verification Failed, Please Try again");
    }
  }, [verificationStatus]);

  React.useEffect(() => {
    if (userDetails?.aadharDetails) {
      setAadhaar(userDetails.aadharDetails.aadharId);
      setIsAadharVerify(true);
      setVerificationStatus("VERIFIED");
    }
    if (userDetails?.userPanCardNumber) {
      setIsPANVerify(true);
      setPAN(userDetails?.userPanCardNumber);
    }
  }, [userDetails]);

  async function validateAadharWithDigiLocker() {
    if (verificationStatus !== "PENDING") {
      return;
    }
    setVerificationStatus("INITIATE");
    initiateDigilocker(userDetailId).then((res) => {
      console.log("initiateDigilocker::::res", res);
      if (res?.success) {
        setVerificationStatus("INITIATED");
        setError(false);
        setErrorMsg("");
        handleDigilockerClick(res?.response.token);
      } else {
        setTechnicalError(true);
      }
    });
  }

  // On Save and submit
  async function onSubmitVerified(e) {
     e.preventDefault();
    if(e.status !== "VERIFIED" && !isAadharVerify) {
      setError(true);
      setErrorMsg("Please verify Aadhaar to proceed");
      return;
    }
    saveFormPath("/aadhaarDetails", userDetails?.detailId);
    dispatch(getUserData(userDetailId));
    setTabValue(6);
    // generateEquifax(userDetails?.user?.userName, userDetails?.detailId);
    navigate("/aadhaarDetails", {
      state: { tabValue: 6, stepperCount: 5, userDetailId: userDetailId },
    });
  }

  function handleBack() {
    navigate("/loanApproved", {
      state: {
        tabValue: 3,
        stepperCount: 3,
        userDetailId: userDetailId || localStorage.getItem("detailId"),
      },
    });
  }

  function getPanOrAadhaarTemplate() {
    if (isAadharVerify) {
      return renderAlreadyVerfied();
    }
    return renderVerifyAadhaar();
  }

  function renderAlreadyVerfied() {
    return (
      <>
        <Typography
          color="textColor"
          variant="h5"
          sx={{ fontWeight: "bold", textAlign: "center", mb: 4 }}
        >
          Validation Complete
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={8} md={6}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <CInput
                  label="Aadhaar Number *"
                  placeholder="Aadhaar Number"
                  disabled={true}
                  value={aadhaar}
                  name="aadhaar"
                />
              </Grid>
              <Grid item sx={{ mt: 5 }}>
                <img src={success} alt="success" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div
          style={{
            pt: 12,
            padding: "100px 0px 0px",
            display: "flex",
            flexDirection: "row",
            justifyContent: `${!matches ? "space-around" : "space-between"}`,
          }}
        >
          {matches && (
            <CButton
              handleClick={() => handleBack()}
              name="Back"
              variant="outlined"
            />
          )}
          <Button
            type="submit"
            sx={{ fontStyle: "Lato" }}
            color="neutral"
            disabled={disabledButton}
            variant="contained"
          >
            Save & Submit
          </Button>
        </div>
      </>
    );
  }

  function renderVerifyAadhaar() {
    return (
      <>
        <Typography
          color="textColor"
          variant="h5"
          sx={{ fontWeight: "bold", textAlign: "center", mb: 4 }}
        >
          Aadhaar Validation
        </Typography>

        <Grid container rowSpacing={1} justifyContent="center">
          <Grid item xs={12} sm={8} md={6} className="digilocker-button">
            {verificationStatus !== "PENDING" && (
              <Grid item justifyContent="center" style={{ display: "grid" }}>
                <CircularLoader></CircularLoader>
              </Grid>
            )}
            <CButton
              handleClick={validateAadharWithDigiLocker}
              variant={
                verificationStatus === "PENDING" ? "contained" : "outlined"
              }
              name={getVericationStatusMessage(verificationStatus)}
              mt={4} // Adjust width as necessary
            />
          </Grid>
          <Grid item>
            <Typography
              color="textColor"
              variant="body2"
              sx={{ textAlign: "center" }}
            >
              Your Aadhaar will be verified via DigiLocker (Govt. of India
              trusted platform).
            </Typography>
          </Grid>
          {errorMsg && <Grid item>
            <Typography
              color="textColor"
              variant="body2"
              sx={{ textAlign: "center", color: 'red' }}
            >
              {errorMsg}
            </Typography>
          </Grid>}
        </Grid>
        <div
          style={{
            pt: 12,
            padding: "100px 0px 0px",
            display: "flex",
            flexDirection: "row",
            justifyContent: `${!matches ? "space-around" : "space-between"}`,
          }}
        >
          {matches && (
            <CButton
              handleClick={() => handleBack()}
              name="Back"
              variant="outlined"
            />
          )}
          <Button
            type="submit"
            sx={{ fontStyle: "Lato" }}
            color="neutral"
            disabled={disabledButton}
            variant="contained"
          >
            Save & Submit
          </Button>
        </div>
      </>
    );
  }

  return (
    <form
      onSubmit={(e) => onSubmitVerified(e)}
      className="applicationFormContainer"
    >
      {error && <CAlert open={error} message={errorMsg} severity="error" />}
      
      {!matches && (
        <Box sx={{ display: "flex" }}>
          <ArrowBackIosIcon onClick={() => handleBack()} />
        </Box>
      )}

      {getPanOrAadhaarTemplate()}

      {technicalError && (
        <ErrorModal
          open={technicalError}
          setOpen={setTechnicalError}
          isTechnicalError={true}
        />
      )}
    </form>
  );
}
